import { z } from "zod";

export const BasketFieldsSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  creationDate: z.string(),
  currencyCode: z.string(),
  valueBrutto: z.number(),
  valueNetto: z.number(),
  discountCode: z.any(),
});
export const PartialBasketFieldsSchema = BasketFieldsSchema.deepPartial();

export const BasketExtraFieldsSchema = z.object({
  availableTemplates: z.array(z.number()),
});
export const PartialBasketExtraFieldsSchema =
  BasketExtraFieldsSchema.deepPartial();

export const BasketSchema = z.intersection(
  BasketFieldsSchema,
  BasketExtraFieldsSchema
);

export type BasketFields = z.infer<typeof BasketFieldsSchema>;
export type PartialBasketFields = z.infer<typeof PartialBasketFieldsSchema>;
export type BasketExtraFields = z.infer<typeof BasketExtraFieldsSchema>;
export type PartialBasketExtraFields = z.infer<
  typeof PartialBasketExtraFieldsSchema
>;
export type Basket = z.infer<typeof BasketSchema>;
